export default __webpack_public_path__ + "assets/images/solutions/69db0be88e52143bd915e31a34f318ba.mp4";